import React from "react";
import PropTypes from "prop-types";
import pdfIconUrl from "../../assets/icons/pdf-reference.svg";

/** Custom PDF document icon for reference list rows. */
const PdfReferenceIcon = ({ className }) => (
  <img src={pdfIconUrl} className={className} width={14} height={17} alt="" aria-hidden />
);

PdfReferenceIcon.propTypes = {
  className: PropTypes.string,
};

export default PdfReferenceIcon;
